module.exports = __webpack_public_path__ + "static/media/OHN-1st-Ammendment-to-Master-Deed.4b79cebe.pdf";